import { useQueryClient } from '@tanstack/react-query';

import { CartErrorTypes } from '@telialt/models/src/EshopModel';
import { toCartError } from '@telialt/utils/src/eshopUtils';
import { useSegment } from '@telialt/utils/src/segment';

import { getCartCache } from '../../helpers/cartQueryUtils';
import { ESHOP_MUTATION_KEY } from '../../model';
import { apiSubmitCoupon } from '../../store/api';
import { useCartQuery } from '../queries/useCartQuery';
import { resetToPreviousCartState, useMutationWithCartRefresh } from './useMutationWithCartRefresh';

export const useSubmitCouponMutation = () => {
    const segment = useSegment();
    const queryClient = useQueryClient();
    const { cartId } = useCartQuery();
    const { mutate, isPending, error } = useMutationWithCartRefresh(
        async (code: string) => {
            const { data: cart } = await apiSubmitCoupon(segment, { cartId }, code);

            return cart;
        },
        {
            mutationKey: [ESHOP_MUTATION_KEY.SUBMIT_COUPON],
            onError: async (axiosCartError, variables) => {
                const cartError = toCartError(axiosCartError);
                if (cartError.type !== CartErrorTypes.VoucherError) {
                    /* just ignore not valid coupon response */
                    return resetToPreviousCartState(queryClient)(axiosCartError, variables, getCartCache(queryClient));
                }
            },
        },
    );

    return {
        submitCouponCode: mutate,
        submitCouponCodeIsLoading: isPending,
        submitCouponCodeError: error,
    };
};
